import { CircularProgress, Stack, StackProps, Typography, styled } from '@mui/material';

export const DialogFileTitle = styled(Typography)(() => ({
  fontSize: '0.75rem',
  fontWeight: 400,
  lineHeight: 1.6,
}));

export const Content = styled(Stack)`
  flex: 1;
  flex-direction: column;
  gap: 0.75rem;
  padding-top: 2rem;
  overflow: hidden;
  width: 100%;
`;

export const Loader = styled((props: StackProps) => (
  <Stack alignItems="center" justifyContent="center" {...props}>
    <CircularProgress />
  </Stack>
))({
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  backdropFilter: 'blur(6px)',
});
